module.exports = __webpack_public_path__ + "img/PAW.Flyer.2.c750a6a7.jpg";